module.exports = __webpack_public_path__ + "static/media/sift.89b4f245.jpg";